// test1256
(1256 && 0);
